import { call, put, takeLatest } from "redux-saga/effects";

// action
import {
  GET_ALL_SCHEDULE_TIMING_LIST,
  getAllScheduleTimingListFail,
  getAllScheduleTimingListSuccess,
} from "../action/getAllScheduleTimingListAction";

// api
import getAllScheduleTimingListApi from "../api/getAllScheduleTimingListApi";

export function* getAllScheduleTimingListSaga(action) {
  try {
    const response = yield call(() => getAllScheduleTimingListApi(action.params));
    if (response.data.status === 1) {
      yield put(getAllScheduleTimingListSuccess(response, action));
    } else {
      yield put(getAllScheduleTimingListFail(response, action));
    }
  } catch (e) {
    yield put(getAllScheduleTimingListFail(e.response, action));
  }
}

export default function* mySaga() {
  yield takeLatest(GET_ALL_SCHEDULE_TIMING_LIST, getAllScheduleTimingListSaga);
}
